module.exports = __webpack_public_path__ + "img/logoteczoav1.a771a9e8.png";